export const MinusIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    height="3"
    width="16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.083 1.792c0 .276-.09.54-.249.736a.78.78 0 01-.6.305H1.766a.78.78 0 01-.601-.305 1.172 1.172 0 01-.25-.736c0-.277.09-.542.25-.737a.78.78 0 01.6-.305h12.467a.78.78 0 01.601.305c.16.195.25.46.25.737z"
      fill="currentColor"
    />
  </svg>
);
